import * as React from 'react';

import {Accordion as AccordionUI} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledAccordion = styled(AccordionUI)(({ theme, scheme }) => ({
    marginBottom: theme.spacing(1),
    borderRadius: 0,
    boxShadow: 'none',
    '&:before': {
        display: 'none',
    },
    '& .MuiAccordionSummary-root': {
        borderLeft: `3px solid ${theme.palette[scheme]?.main || theme.palette.primary.main}ff`,
        backgroundColor: `${theme.palette[scheme]?.light || theme.palette.primary.light}44`,
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
        },
        '&:hover': {
            backgroundColor: theme.palette[scheme]?.light || theme.palette.secondary.light,
        },
        '& .MuiAccordionSummary-content': {
            display: 'flex',
            alignItems: 'center',
            '& .MuiTypography-root': {
                fontSize: '0.9rem',
                fontWeight: 500,
            },
        },
        '& .MuiAccordionSummary-expandIconWrapper': {
            marginRight: theme.spacing(2),
            color: theme.palette[scheme]?.main || theme.palette.primary.main,
        },
    },
    '& .MuiAccordionDetails-root': {
        padding: theme.spacing(2),
        borderLeft: `3px solid ${theme.palette[scheme]?.light || theme.palette.primary.light}aa`,
        backgroundColor: `${theme.palette[scheme]?.light || theme.palette.secondary.light}66`,
        position: 'relative',
    },
    '& .MuiAccordionActions-root': {
        padding: theme.spacing(2),
        justifyContent: 'space-between',
        borderLeft: `3px solid ${theme.palette[scheme]?.light || theme.palette.primary.light}aa`,
        backgroundColor: `${theme.palette[scheme]?.light || theme.palette.secondary.light}66`,
    },
}));


export const Accordion = ({ children, ...rest }) => {

    return <StyledAccordion {...rest}>{children}</StyledAccordion>;
};